import React, { useEffect, useState } from 'react';

function ScannerMode({ onScanResult, eventId }) {
    const [buffer, setBuffer] = useState('');
    const [lastKeyTime, setLastKeyTime] = useState(Date.now());

    useEffect(() => {
        
        const handleKeyPress = (e) => {
            const now = Date.now();
            const timeDiff = now - lastKeyTime;

            // If more than 100ms between keys, start new scan
            if (timeDiff > 100) {
                setBuffer('');
            }

            setLastKeyTime(now);

            // Enter key means scan complete
            if (e.key === 'Enter') {
                if (buffer.length > 0) {
                    console.log('Scanned:', buffer);
                    onScanResult(buffer);
                    setBuffer('');
                }
            } else if (e.key.length === 1) {
                // Regular character
                setBuffer(prev => prev + e.key);
            }
        };

        window.addEventListener('keypress', handleKeyPress);

        return () => {
            window.removeEventListener('keypress', handleKeyPress);
        };
    }, [buffer, lastKeyTime, onScanResult]);

    return (
        <div className="scanner-ready">
            <h2>Scanner Mode Active</h2>
            <p>Ready to scan with Zebra TC26</p>
            <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#999' }}>
                Press the trigger button to scan a QR code
            </p>
            {buffer && (
                <div style={{ marginTop: '1rem', color: 'var(--dfp-blue)', fontFamily: 'monospace' }}>
                    Scanning: {buffer}
                </div>
            )}
        </div>
    );
}

export default ScannerMode;
